import React, { useState, useEffect } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AdminSidebar from "../../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../../component/AdminComp/AdminTopbar";

const AddSellerTerms = () => {
  const [termsDescription, setTermsDescription] = useState("");

  // Fetch existing terms from API
  const fetchTerms = async () => {
    try {
      const response = await axios.get(`${baseurl}getTermsSeller`);
      if (response.data.data) {
        setTermsDescription(response.data.data.data); // Prefill data
      }
    } catch (error) {
      console.error("Error fetching terms:", error);
    }
  };

  // Fetch terms on component mount
  useEffect(() => {
    fetchTerms();
  }, []);

  // Handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!termsDescription.trim()) {
      Swal.fire("Validation Error", "Description is required", "warning");
      return;
    }

    try {
      await axios.post(`${baseurl}updateTermsSeller`, { privacy: termsDescription });

      Swal.fire("Success", "Terms And Condition For Sellers updated successfully!", "success").then(() => {
        fetchTerms(); // Refresh after update
      });
    } catch (error) {
      console.error("Error updating terms:", error);
      Swal.fire("Error", "Failed to update terms. Try again!", "error");
    }
  };

  return (
    <div className="App" style={{ display: "flex" }}>
      <AdminSidebar />
      <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
        <AdminTopbar />

        <div className="container-fluid">
          <h4 className="mb-3 text-start">Shipping Policy</h4>

          <div className="crd1 mb-3">
            <form onSubmit={handleSubmit}>
              {/* Quill Editor */}
              <div className="col-md-12 mb-3">
                <ReactQuill
                  value={termsDescription}
                  onChange={setTermsDescription}
                  modules={{
                    toolbar: [
                      ["bold", "italic", "underline", "strike"],
                      [{ align: [] }],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["link"],
                      [{ header: "1" }, { header: "2" }, { font: [] }],
                      [{ color: [] }, { background: [] }],
                      ["blockquote"],
                      ["code-block"],
                      ["undo", "redo"],
                    ],
                  }}
                  className="quill-editor"
                />
              </div>

              {/* Submit Button */}
              <div className="col-md-12">
                <button type="submit" className="btn btn-primary w-100">
                  Update Shipping Policy
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSellerTerms;
